import { TrustpilotSection } from 'components/home-page/trustpilot-section/TrustpilotSection';
import AsSeenOn from 'components/home-page-2026/as-seen-on';
import { HeroWithForwardedRef } from 'components/home-page-2026/hero';
import HowItWorksV2 from 'components/home-page-2026/how-it-works/HowItWorksV2';
import Prizes from 'components/home-page-2026/prizes';
import QuickAnswers from 'components/home-page-2026/quick-answers';
import Trees from 'components/home-page-2026/trees';
import Winners from 'components/home-page-2026/winners';
import MainLayout from 'components/layout/MainLayout';
import { useEffect, useRef, useState } from 'react';
import { WinnerHomepage } from 'utils/plasmicCMS';

export interface HomePage2026Props {
  nextDrawDate: string;
  prizes: HomePagePrize[];
  winners: WinnerHomepage[];
}

export interface HomePagePrize {
  title: string;
  imageSrc: string;
  imageAlt: string;
  mainCategory: string;
  href: string;
}

export interface HomePagePrize {
  title: string;
  imageSrc: string;
  imageAlt: string;
  mainCategory: string;
  href: string;
}

const HomePage2026 = ({ nextDrawDate, prizes, winners }: HomePage2026Props) => {
  const [scrolledEnough, setScrolledEnough] = useState(false);
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const rect = heroRef.current?.getBoundingClientRect();
      if (!rect) return;
      setScrolledEnough(-rect.top >= rect.height * 0.25);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <MainLayout
      limitItemWidths
      clearHeader
      displayHeaderOnScroll
      footerBackground="absoluteWhite"
    >
      <div className="daymadeTypographyReset">
        <HeroWithForwardedRef ref={heroRef} nextDrawDate={nextDrawDate} />
        <AsSeenOn alternativeColour={scrolledEnough} />
        <Prizes prizes={prizes} />
        <Winners winners={winners} background="white" />
        <HowItWorksV2 background="darkBlue" />
        <TrustpilotSection variant="HomePage2026" />
        <Trees />
        <QuickAnswers />
      </div>
    </MainLayout>
  );
};

export default HomePage2026;
